import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { LoadingContent } from '../../../components'
import { history } from '../../../helpers'
import { modalAlertaClean, modalAlertaInfo } from '../../../layout/redux/layoutActions'
import { verificarExisteEmpresaPdca } from './redux/pdcaBaseActions'
import './pdcaLayout.scss'

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { grupos, grupo, filters, empresa, categoria, sistema } = useSelector(state => state.layoutState)
  const { erroContexto } = useSelector(state => state.pdcaState.pdcaBaseState)

  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)

  const [validando, setValidando] = useState(true)
  const [falhaValidacao, setFalhaValidacao] = useState(false)
  const popupJaAbertoRef = useRef(false)

  useEffect(() => {
    const validarEntrada = async () => {
      setValidando(true)
      setFalhaValidacao(false)
      popupJaAbertoRef.current = false

      const result = await dispatch(verificarExisteEmpresaPdca(idProjetos))

      if (result?.ok) {
        if (result.contexto?.empresaPdcaExiste) {
          history.push(`/myprojects/${idProjetos}/pdca/priorities`)
        } else {
          history.push(`/myprojects/${idProjetos}/pdca/setup`)
        }
        return
      }

      setFalhaValidacao(true)

      if (!popupJaAbertoRef.current) {
        popupJaAbertoRef.current = true

        dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            btnAction: () => dispatch(modalAlertaClean()),
            show: true,
          })
        )
      }

      setValidando(false)
    }

    if (idProjetos) {
      validarEntrada()
    }
  }, [dispatch, idProjetos, sistema.idioma])

  if (validando) {
    return (
      <div className='box-pdca-route-entry'>
        <LoadingContent
          show={true}
          title={nls.loadingContextoPdca}
          height="calc(100vh - 150px)"
        >
          <div />
        </LoadingContent>
      </div>
    )
  }

  if (falhaValidacao) {
    return (
      <div className='box-pdca-route-entry'>
        <div className='box-pdca-route-entry-error'>
          <h3>{nls.erroCarregarModuloPdcaTitulo}</h3>
          <p>{erroContexto?.complemento || nls.erroCarregarModuloPdcaTexto}</p>
        </div>
      </div>
    )
  }

  return null
}